module.exports = __webpack_public_path__ + "img/activeAlternate.1562f079.png";